/* Saimour theme script. Vanilla, no dependencies. */
(function () {
  'use strict';

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('sl-config').textContent); } catch (e) { CFG = {}; }
  var D = CFG.delivery || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || CFG.moneyFormat || '${{amount}}';
    function fmt(n, dec, th, ds) {
      dec = dec === undefined ? 2 : dec; th = th || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(dec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? ds + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.SL = window.SL || {};
  window.SL.formatMoney = formatMoney;

  /* ---------- Delivery dates ---------- */
  var offsetH = Number(D.utcOffset == null ? -5 : D.utcOffset);
  function storeNow() {
    // A Date whose UTC fields read as the store's wall clock.
    return new Date(Date.now() + offsetH * 3600000);
  }
  function isWeekend(d) { var w = d.getUTCDay(); return w === 0 || w === 6; }
  function addBizDays(d, n) {
    var r = new Date(d.getTime());
    var added = 0;
    while (added < n) { r.setUTCDate(r.getUTCDate() + 1); if (!isWeekend(r)) added++; }
    return r;
  }
  function nextBizDay(d) { var r = new Date(d.getTime()); do { r.setUTCDate(r.getUTCDate() + 1); } while (isWeekend(r)); return r; }
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAYS_L = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTHS_L = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function fDay(d) { return DAYS[d.getUTCDay()] + ', ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate(); }
  function fShort(d) { return MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate(); }
  function fLong(d) { return DAYS_L[d.getUTCDay()] + ', ' + MONTHS_L[d.getUTCMonth()] + ' ' + d.getUTCDate(); }
  function fLeft(ms) {
    var m = Math.max(0, Math.floor(ms / 60000));
    var h = Math.floor(m / 60); m = m % 60;
    return h > 0 ? h + 'h ' + m + 'm' : m + 'm';
  }

  function estimate() {
    var now = storeNow();
    var cutoffH = Number(D.cutoffHour == null ? 14 : D.cutoffHour);
    var processing = Number(D.processing == null ? 1 : D.processing);
    var tMin = Number(D.transitMin == null ? 3 : D.transitMin);
    var tMax = Number(D.transitMax == null ? 6 : D.transitMax);
    if (tMax < tMin) tMax = tMin;

    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    var cutoffToday = new Date(today.getTime() + cutoffH * 3600000);
    var start = today;
    var beforeCutoff = !isWeekend(today) && now < cutoffToday;
    if (!beforeCutoff) start = nextBizDay(today);
    var ships = processing > 0 ? addBizDays(start, processing) : start;
    var min = addBizDays(ships, tMin);
    var max = addBizDays(ships, tMax);
    var nextCutoff = beforeCutoff ? cutoffToday : new Date(start.getTime() + cutoffH * 3600000);

    // Christmas window
    var ob = null;
    if (D.orderBy && /^\d{4}-\d{2}-\d{2}$/.test(D.orderBy)) {
      var p = D.orderBy.split('-');
      ob = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], cutoffH, 0, 0));
    }
    var year = ob ? ob.getUTCFullYear() : now.getUTCFullYear();
    var xmas = new Date(Date.UTC(year, 11, 25));
    var xmasMode = !!ob && now < xmas && now > new Date(Date.UTC(year, 8, 1));
    var late = xmasMode && (now > ob || max >= xmas);

    return {
      now: now, min: min, max: max, late: late, xmasMode: xmasMode, orderBy: ob,
      countdownMs: nextCutoff - now,
      orderByMs: ob ? ob - now : 0
    };
  }

  function fillTokens(root, est) {
    var map = {
      min: fDay(est.min), max: fDay(est.max), maxshort: fShort(est.max), minshort: fShort(est.min),
      countdown: fLeft(est.countdownMs),
      orderby: est.orderBy ? fDay(est.orderBy) : '', orderbylong: est.orderBy ? fLong(est.orderBy) : '',
      orderbyshort: est.orderBy ? fShort(est.orderBy) : '',
      days: est.orderBy ? String(Math.max(0, Math.ceil(est.orderByMs / 86400000))) : ''
    };
    $$('[data-tok]', root).forEach(function (el) {
      var k = el.getAttribute('data-tok');
      if (map[k] != null) el.textContent = map[k];
    });
  }

  function renderDelivery() {
    if (!D.enabled) return;
    var est = estimate();
    $$('[data-delivery]').forEach(function (box) {
      var ok = $('[data-delivery-ok]', box);
      var late = $('[data-delivery-late]', box);
      var showLate = est.late && late;
      if (ok) ok.hidden = !!showLate;
      if (late) late.hidden = !showLate;
      box.classList.toggle('is-late', !!est.late);
      box.hidden = false;
      fillTokens(box, est);
    });
    fillTokens(document, est);
  }
  renderDelivery();
  setInterval(renderDelivery, 30000);
  window.SL.renderDelivery = renderDelivery;

  /* ---------- Christmas countdown ---------- */
  function initCountdowns(scope) {
  $$('[data-countdown]', scope).forEach(function (el) {
    function tick() {
      var est = estimate();
      var ms = est.orderBy ? est.orderBy - est.now : -1;
      var closed = !D.enabled || !est.orderBy || ms <= 0;
      el.classList.toggle('is-closed', closed);
      var openEls = $$('[data-countdown-open]', el), closedEls = $$('[data-countdown-closed]', el);
      openEls.forEach(function (n) { n.hidden = closed; });
      closedEls.forEach(function (n) { n.hidden = !closed; });
      if (closed) return;
      var mins = Math.floor(ms / 60000);
      var d = Math.floor(mins / 1440), h = Math.floor((mins % 1440) / 60), m = mins % 60;
      var set = function (k, v) { var n = $('[data-cd="' + k + '"]', el); if (n) n.textContent = v < 10 ? '0' + v : String(v); };
      set('d', d); set('h', h); set('m', m);
      fillTokens(el, est);
    }
    tick();
    setInterval(tick, 20000);
  });
  }
  initCountdowns(document);

  /* ---------- Header ---------- */
  var header = $('[data-header]');
  if (header && header.classList.contains('header--overlay')) {
    var onScroll = function () { header.classList.toggle('is-top', window.scrollY < 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Rails ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rail-prev],[data-rail-next]');
    if (!btn) return;
    var scope = btn.closest('.section') || document;
    var rail = $('[data-rail]', scope);
    if (!rail) return;
    var dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
    var item = rail.firstElementChild;
    var step = item ? item.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  /* ---------- Height finder ---------- */
  function initFinders(scope) {
  $$('[data-finder]', scope).forEach(function (root) {
    var choices = $$('[data-finder-choice]', root);
    var tree = $('.fv-tree', root), ceiling = $('.fv-ceiling', root), gap = $('.fv-gap', root);
    var answer = $('[data-finder-answer]', root), note = $('[data-finder-note]', root), cta = $('[data-finder-cta]', root);
    var ctaLabel = $('[data-finder-cta-label]', root);
    var ceilLbl = $('[data-finder-ceil]', root);
    var maxFt = 12, floorY = 410, unit = 30;
    function select(btn) {
      choices.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var c = parseFloat(btn.getAttribute('data-ceiling')) || 8;
      var t = parseFloat(btn.getAttribute('data-tree')) || c - 1;
      var ceilY = floorY - c * unit;
      if (tree) tree.style.transform = 'scale(' + (t / maxFt) + ')';
      if (ceiling) ceiling.style.transform = 'translateY(' + ceilY + 'px)';
      if (gap) {
        var gapPx = Math.max(0, c * unit - 355 * (t / maxFt)); // tree artwork is 355px tall at 12 ft
        gap.style.transform = 'translateY(' + ceilY + 'px)';
        var line = $('.fv-gap-line', gap); if (line) line.setAttribute('y2', String(gapPx));
        var gl = $('.fv-gap-label', gap); if (gl) { gl.setAttribute('y', String(gapPx / 2 + 4)); gl.textContent = Math.round((c - t) * 12) + ' in'; }
      }
      if (ceilLbl) ceilLbl.textContent = btn.getAttribute('data-ceiling-label') + ' ceiling';
      if (answer) answer.textContent = btn.getAttribute('data-answer');
      if (note) note.textContent = btn.getAttribute('data-note');
      if (cta) {
        var url = btn.getAttribute('data-url');
        if (url) { cta.setAttribute('href', url); cta.hidden = false; } else { cta.hidden = true; }
        if (ctaLabel) ctaLabel.textContent = btn.getAttribute('data-cta');
      }
    }
    choices.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
    var start = choices.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || choices[1] || choices[0];
    if (start) select(start);
  });
  }
  initFinders(document);

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track) return null;
    var slides = $$('[data-media-id]', track);
    var thumbs = $$('[data-thumb]', root);
    var count = $('[data-gallery-count]', root);
    var current = 0;
    function update(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    function go(i, smooth) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      update(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) update(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, current - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(slides.length - 1, current + 1)); });
    update(0);
    return {
      showMedia: function (id, smooth) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(id)) { go(i, smooth); return; }
        }
      }
    };
  }

  /* ---------- Product form ---------- */
  function parseFeet(str) {
    var m = String(str || '').match(/(\d+(?:\.\d+)?)\s*(?:ft|foot|feet|'|’)/i);
    return m ? parseFloat(m[1]) : null;
  }
  function fmtFt(n) { return (Math.round(n * 2) / 2).toString().replace(/\.0$/, '') + ' ft'; }

  function initProducts(scope) {
  $$('[data-product]', scope).forEach(function (root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var form = $('form[data-product-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var gallery = initGallery(root);
    var fitIndex = typeof data.fitOption === 'number' ? data.fitOption : -1;

    var startVariant = null;
    var startId = idInput ? String(idInput.value) : '';
    for (var sv = 0; sv < variants.length; sv++) { if (String(variants[sv].id) === startId) { startVariant = variants[sv]; break; } }
    if (!startVariant) startVariant = variants[0] || { options: [] };
    var currentOpts = (startVariant.options || []).slice();
    function optIndex(fs, fallback) {
      var a = fs.getAttribute('data-option-index');
      return a !== null && a !== '' ? parseInt(a, 10) : fallback;
    }
    function selectedOptions() {
      var opts = currentOpts.slice();
      $$('[data-option]', root).forEach(function (fs, n) {
        var c = $('input:checked', fs);
        if (c) opts[optIndex(fs, n)] = c.value;
      });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      $$('[data-option]', root).forEach(function (fs, n) {
        var idx = optIndex(fs, n);
        $$('.opt__value', fs).forEach(function (wrap) {
          var input = $('input', wrap);
          var test = opts.slice(); test[idx] = input.value;
          var v = findVariant(test);
          wrap.classList.toggle('is-unavailable', !v || !v.available);
          var pr = $('[data-opt-price]', wrap);
          if (pr && v) pr.textContent = formatMoney(v.price);
        });
        var lbl = $('[data-option-selected]', fs);
        if (lbl) lbl.textContent = opts[idx] || '';
      });
    }
    function setText(sel, txt) { $$(sel, root).forEach(function (n) { n.textContent = txt; }); }

    function update(push) {
      var opts = selectedOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      var atcs = $$('[data-atc]', root).concat($$('[data-sticky-atc]'));
      if (!v) {
        atcs.forEach(function (b) { b.disabled = true; var l = $('[data-atc-label]', b); if (l) l.textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      currentOpts = v.options.slice();
      // Highlight the matching row in the dimensions table
      if (fitIndex >= 0) {
        var hv = String(v.options[fitIndex] || '').toLowerCase().replace(/\s+/g, '');
        $$('[data-dims-row]').forEach(function (row) {
          var on = String(row.getAttribute('data-dims-row')).toLowerCase().replace(/\s+/g, '') === hv;
          row.classList.toggle('is-active', on);
          if (on) {
            $$('[data-dims-h]').forEach(function (n) { n.textContent = row.getAttribute('data-dims-row'); });
            $$('[data-dims-w]').forEach(function (n) { n.textContent = row.getAttribute('data-w'); });
          }
        });
      }
      setText('[data-price]', formatMoney(v.price));
      $$('[data-compare]', root).forEach(function (n) {
        n.hidden = !(v.compare_at_price > v.price);
        n.textContent = v.compare_at_price ? formatMoney(v.compare_at_price) : '';
      });
      $$('[data-save]', root).forEach(function (n) {
        var on = v.compare_at_price > v.price;
        n.hidden = !on;
        if (on) n.textContent = 'Save ' + formatMoney(v.compare_at_price - v.price).replace(/[.,]00(?=\D*$)/, '');
      });
      atcs.forEach(function (b) {
        b.disabled = !v.available;
        var l = $('[data-atc-label]', b); if (l) l.textContent = v.available ? (b.getAttribute('data-label') || 'Add to cart') : 'Sold out';
        var p = $('[data-atc-price]', b); if (p) p.textContent = formatMoney(v.price);
      });
      $$('[data-stock]', root).forEach(function (n) {
        var t = $('[data-stock-text]', n);
        var def = n.getAttribute('data-default') || '';
        n.hidden = false;
        n.classList.toggle('stock-low', !v.available || v.low != null);
        if (!t) return;
        if (!v.available) t.textContent = 'Sold out in this option';
        else if (v.low != null) t.textContent = 'Only ' + v.low + ' left, ships within 1 business day';
        else if (def) t.textContent = def;
        else n.hidden = true;
      });
      // Fit note: tree height to minimum ceiling
      $$('[data-fit]', root).forEach(function (n) {
        var ft = fitIndex >= 0 ? parseFeet(v.options[fitIndex]) : null;
        if (!ft) { n.hidden = true; return; }
        var ceil = Math.ceil((ft + 0.5) * 2) / 2;
        n.hidden = false;
        var t = $('[data-fit-text]', n); if (t) t.textContent = fmtFt(ceil);
      });
      $$('[data-sticky-variant]').forEach(function (n) { n.textContent = v.title === 'Default Title' ? '' : v.title; });
      $$('[data-sticky-price]').forEach(function (n) { n.textContent = formatMoney(v.price); });
      if (gallery && v.media) gallery.showMedia(v.media, !!push);
      if (push && data.url && window.history.replaceState && root.hasAttribute('data-update-url')) {
        window.history.replaceState({}, '', data.url + '?variant=' + v.id);
      }
      root.dispatchEvent(new CustomEvent('variant:change', { detail: v, bubbles: true }));
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) update(true); });
    update(false);

    // Quantity steppers
    $$('[data-qty]', root).forEach(function (q) {
      var input = $('input', q);
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var n = parseInt(input.value, 10) || 1;
        n = b.hasAttribute('data-qty-minus') ? Math.max(1, n - 1) : n + 1;
        input.value = n;
      });
    });

    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (CFG.cartType === 'page' && !$$('[data-addon]:checked', root).length) return;
      e.preventDefault();
      var btn = $('[data-atc]', form);
      var err = $('[data-form-error]', root);
      if (err) err.hidden = true;
      var qtyInput = $('input[name="quantity"]', form);
      var items = [{ id: Number(idInput.value), quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1 }];
      $$('[data-addon]:checked', root).forEach(function (a) { items.push({ id: Number(a.value), quantity: 1 }); });
      if (btn) btn.classList.add('is-loading');
      addItems(items).then(function () {
        if (btn) btn.classList.remove('is-loading');
      }).catch(function (msg) {
        if (btn) btn.classList.remove('is-loading');
        if (err) { err.textContent = msg || 'Could not add to cart. Please try again.'; err.hidden = false; }
      });
    });

    // Sticky bar
    var sticky = $('[data-sticky-buy]');
    var watch = $('[data-atc]', root);
    if (sticky && watch && 'IntersectionObserver' in window && root.hasAttribute('data-main-product')) {
      var footer = $('.footer');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === watch) {
            var below = en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !en.isIntersecting && below);
          }
        });
      });
      io.observe(watch);
      var sbtn = $('[data-sticky-atc]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
      if (footer) {
        new IntersectionObserver(function (en) { if (en[0].isIntersecting) sticky.classList.remove('is-visible'); }).observe(footer);
      }
    }
  });
  }
  initProducts(document);

  /* ---------- Cart ---------- */
  var drawer = document.getElementById('CartDrawer');
  var lastFocus = null;
  function openDrawer(el) {
    el = el || drawer;
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var c = $('[data-drawer-close].icon-btn', el) || $('[data-drawer-close]', el);
    if (c) setTimeout(function () { c.focus(); }, 60);
  }
  function closeDrawer(el) {
    var list = el ? [el] : $$('.drawer.is-open');
    list.forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.SL.openCart = function () { openDrawer(drawer); };

  function sectionIds() {
    var ids = [];
    if (drawer) ids.push('cart-drawer');
    $$('[data-cart-section]').forEach(function (s) { var id = s.getAttribute('data-cart-section'); if (ids.indexOf(id) < 0) ids.push(id); });
    return ids;
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-root]');
      var target = id === 'cart-drawer' ? (drawer && $('[data-cart-root]', drawer)) : $('[data-cart-section="' + id + '"] [data-cart-root]');
      if (fresh && target) target.replaceWith(fresh);
    });
    renderDelivery();
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw (j.description || j.message || 'Something went wrong.');
        return j;
      });
    });
  }
  function refreshCount() {
    return fetch((CFG.routes && CFG.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }
  function addItems(items) {
    var url = (CFG.routes && CFG.routes.cartAdd || '/cart/add') + '.js';
    return postJSON(url, { items: items, sections: sectionIds().join(','), sections_url: window.location.pathname })
      .then(function (res) {
        applySections(res.sections);
        return refreshCount();
      }).then(function () {
        if (CFG.cartType === 'page' || !drawer) { window.location.href = (CFG.routes && CFG.routes.cart) || '/cart'; return; }
        closeDrawer();
        openDrawer(drawer);
      });
  }
  window.SL.addItems = addItems;
  function changeLine(line, qty, el) {
    var root = el && el.closest('[data-cart-root]');
    if (root) root.classList.add('is-busy');
    var url = (CFG.routes && CFG.routes.cartChange || '/cart/change') + '.js';
    return postJSON(url, { line: line, quantity: qty, sections: sectionIds().join(','), sections_url: window.location.pathname })
      .then(function (res) { applySections(res.sections); setCount(res.item_count); })
      .catch(function (msg) { if (root) root.classList.remove('is-busy'); window.alert(msg); });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && drawer && CFG.cartType !== 'page') { e.preventDefault(); openDrawer(drawer); return; }
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { var target = document.getElementById(opener.getAttribute('data-drawer-open')); if (target) { e.preventDefault(); openDrawer(target); } return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    var minus = e.target.closest('[data-line-minus]'), plus = e.target.closest('[data-line-plus]'), rm = e.target.closest('[data-line-remove]');
    var b = minus || plus || rm;
    if (b) {
      e.preventDefault();
      var line = Number(b.getAttribute('data-line'));
      var q = Number(b.getAttribute('data-qty')) || 0;
      var next = rm ? 0 : (minus ? Math.max(0, q - 1) : q + 1);
      changeLine(line, next, b);
      return;
    }
    var up = e.target.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      up.classList.add('is-loading');
      addItems([{ id: Number(up.getAttribute('data-upsell-add')), quantity: 1 }]).catch(function () { up.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && $('.drawer.is-open')) closeDrawer();
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
        window.location.search = params.toString();
      }, e.target.type === 'number' ? 800 : 120);
    });
  });
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', sortSel.value);
    params.delete('page');
    window.location.search = params.toString();
  });

  /* ---------- Rotators (announcement, rotating words) ---------- */
  function initRotators(scope) {
    $$('[data-rotator]', scope).forEach(function (root) {
      var items = $$('[data-rotator-item]', root);
      if (items.length < 2 || root.__rot) return;
      var ms = parseInt(root.getAttribute('data-rotator'), 10) || 4000;
      var i = 0;
      root.__rot = setInterval(function () {
        if (document.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }
  initRotators(document);

  /* ---------- Hero slideshow ---------- */
  function initSlideshows(scope) {
    $$('[data-slideshow]', scope).forEach(function (root) {
      var slides = $$('[data-slide]', root), dots = $$('[data-slide-dot]', root);
      if (slides.length < 2 || root.__show) return;
      var ms = parseInt(root.getAttribute('data-slideshow'), 10) || 7000, i = 0;
      function go(n) {
        slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
      }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); restart(); }); });
      function restart() { clearInterval(root.__show); root.__show = setInterval(function () { if (!document.hidden) go(i + 1); }, ms); }
      restart();
    });
  }
  initSlideshows(document);

  /* ---------- Tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var scope = tab.closest('.section') || document;
    $$('[data-tab]', scope).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    var id = tab.getAttribute('aria-controls');
    $$('[data-tab-panel]', scope).forEach(function (p) { p.hidden = p.id !== id; });
  });

  /* ---------- Product recommendations ---------- */
  function initRecs(scope) {
  $$('[data-recs]', scope).forEach(function (sec) {
    if (sec.querySelector('.grid')) return;
    fetch(sec.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; renderDelivery(); initRails(sec); }
    }).catch(function () {});
  });
  }
  initRecs(document);

  /* ---------- Customer reviews: star filter, sorting, pages ---------- */
  function initReviews(scope) {
  $$('[data-reviews]', scope).forEach(function (sec) {
    var wrap = $('[data-reviews-items]', sec);
    if (!wrap || sec.__rv) return;
    sec.__rv = true;
    var per = parseInt(sec.getAttribute('data-per-page'), 10) || 10;
    var all = $$('[data-review]', wrap);
    all.forEach(function (c, i) { c.__i = i; });
    var state = { star: 0, sort: 'newest', page: 1 };
    var pager = $('[data-reviews-pager]', sec), status = $('[data-reviews-status]', sec);
    var clear = $('[data-filter-clear]', sec), sortSel = $('[data-reviews-sort]', sec);
    function dateOf(c) { var t = Date.parse(c.getAttribute('data-date') || ''); return isNaN(t) ? -c.__i : t; }
    function render() {
      var list = all.filter(function (c) { return !state.star || parseInt(c.getAttribute('data-rating'), 10) === state.star; });
      list.sort(function (a, b) {
        var ra = parseInt(a.getAttribute('data-rating'), 10), rb = parseInt(b.getAttribute('data-rating'), 10);
        if (state.sort === 'highest') return rb - ra || dateOf(b) - dateOf(a);
        if (state.sort === 'lowest') return ra - rb || dateOf(b) - dateOf(a);
        if (state.sort === 'photos') return (b.getAttribute('data-photo') === 'true') - (a.getAttribute('data-photo') === 'true') || dateOf(b) - dateOf(a);
        return dateOf(b) - dateOf(a);
      });
      var pages = Math.max(1, Math.ceil(list.length / per));
      if (state.page > pages) state.page = pages;
      var start = (state.page - 1) * per, end = start + per;
      all.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c, i) { wrap.appendChild(c); c.hidden = i < start || i >= end; });
      if (status) status.textContent = list.length ? 'Showing ' + (start + 1) + ' to ' + Math.min(end, list.length) + ' of ' + list.length + (list.length === 1 ? ' review' : ' reviews') : 'No reviews with this rating yet.';
      if (pager) {
        pager.innerHTML = '';
        if (pages > 1) {
          for (var p = 1; p <= pages; p++) {
            var b = document.createElement('button');
            b.type = 'button'; b.textContent = p; b.setAttribute('data-page', p);
            if (p === state.page) b.setAttribute('aria-current', 'page');
            pager.appendChild(b);
          }
        }
      }
      $$('[data-filter-rating]', sec).forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-filter-rating'), 10) === state.star)); });
      if (clear) clear.hidden = !state.star;
    }
    sec.addEventListener('click', function (e) {
      var f = e.target.closest('[data-filter-rating]');
      if (f) { var n = parseInt(f.getAttribute('data-filter-rating'), 10); state.star = state.star === n ? 0 : n; state.page = 1; render(); return; }
      if (e.target.closest('[data-filter-clear]')) { state.star = 0; state.page = 1; render(); return; }
      var pg = e.target.closest('[data-page]');
      if (pg) { state.page = parseInt(pg.getAttribute('data-page'), 10); render(); var top = sec.getBoundingClientRect().top + window.scrollY - 90; window.scrollTo({ top: top, behavior: 'smooth' }); }
    });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; state.page = 1; render(); });
    render();
    // Fill an empty rating badge under the title from this section's reviews
    var sum = $('[data-reviews-summary]', sec);
    var count = sum ? parseInt(sum.getAttribute('data-count'), 10) : 0;
    if (count > 0) {
      var avg = parseFloat(sum.getAttribute('data-avg')) || 0;
      $$('[data-rating-sync]').forEach(function (bd) {
        var link = bd.getAttribute('data-link') || '#' + sec.id;
        bd.innerHTML = '<span class="stars__row" style="--pct:' + Math.round(avg * 20) + '%" aria-hidden="true"></span><span class="rating__avg">' + avg.toFixed(1) + '</span><a class="rating__count" href="' + link + '" data-scroll-reviews>' + count + (count === 1 ? ' review' : ' reviews') + '</a>';
        bd.hidden = false;
      });
    }
  });
  }
  initReviews(document);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-scroll-reviews]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').split('#')[1];
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  });

  /* ---------- Swipe rails: dots instead of a scrollbar ---------- */
  function initRails(scope) {
    $$('.carousel, .tiles, [data-rail]', scope).forEach(function (rail) {
      if (rail.__rail) { rail.__rail(); return; }
      var dots = document.createElement('div');
      dots.className = 'rail-dots';
      dots.setAttribute('aria-hidden', 'true');
      rail.parentNode.insertBefore(dots, rail.nextSibling);
      function items() { return Array.prototype.filter.call(rail.children, function (c) { return c.offsetParent !== null; }); }
      function build() {
        var list = items();
        var over = !rail.hidden && rail.scrollWidth > rail.clientWidth + 4 && list.length > 1;
        dots.hidden = !over;
        dots.innerHTML = '';
        if (!over) return;
        list.forEach(function (it, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.tabIndex = -1;
          b.addEventListener('click', function () { rail.scrollTo({ left: it.offsetLeft - list[0].offsetLeft, behavior: 'smooth' }); });
          dots.appendChild(b);
        });
        update();
      }
      function update() {
        var list = items(); if (!list.length) return;
        var x = rail.scrollLeft, best = 0, bd = Infinity;
        list.forEach(function (it, i) { var d = Math.abs((it.offsetLeft - list[0].offsetLeft) - x); if (d < bd) { bd = d; best = i; } });
        if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) best = list.length - 1;
        $$('button', dots).forEach(function (b, i) { b.classList.toggle('is-active', i === best); });
      }
      var t; rail.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
      window.addEventListener('resize', function () { clearTimeout(rail.__rt); rail.__rt = setTimeout(build, 150); });
      rail.__rail = build;
      build();
    });
  }
  initRails(document);
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (!q || !window.SL || !window.SL.addItems) return;
    e.preventDefault();
    q.classList.add('is-loading'); q.disabled = true;
    window.SL.addItems([{ id: Number(q.getAttribute('data-quick-add')), quantity: 1 }]).then(function () {
      q.classList.remove('is-loading'); q.disabled = false;
    }).catch(function () { q.classList.remove('is-loading'); q.disabled = false; var card = q.closest('.also__item, .pgi, .cart-up'); var a = card && card.querySelector('a[href]'); if (a) window.location.href = a.href; });
  });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-tab]')) setTimeout(function () { initRails(document); }, 30); });


  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    initCountdowns(t); initFinders(t); initProducts(t); initRecs(t); initRotators(t); initSlideshows(t); initReviews(t); initRails(t); renderDelivery(); if (t.querySelector('#SLBot') && window.SLBotInit) window.SLBotInit();
  });
})();
